import request from '@/axios'
import type { LangListParams, LangItem } from './types'

// 获取语言列表
export const getLangListApi = (params: LangListParams) => {
  return request.get({ url: '/admin/language', params })
}

// 获取单个语言详情
export const getLangApi = (id: string | number) => {
  return request.get({ url: `/admin/language/${id}` })
}

// 新增/编辑语言
export const saveLangApi = (data: LangItem) => {
  return request.post({ url: '/admin/language', data })
}

// 删除语言
export const deleteLangApi = (id: string | number) => {
  return request.delete({ url: `/admin/language/${id}` })
}
